import { render, staticRenderFns } from "./AdvanceCheck.vue?vue&type=template&id=0520bc0c&scoped=true"
import script from "./AdvanceCheck.vue?vue&type=script&lang=js"
export * from "./AdvanceCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0520bc0c",
  null
  
)

export default component.exports